import axios from './configObra/config-obra'

const defaultRoute = '/equipments'

export default {
  return: async (body) => {
    const data = axios.post(`${defaultRoute}/return`, body)

    return data
  },
  findReturn: async (patrimony) => {
    const data = axios.get(`${defaultRoute}/find-request/${patrimony}`, {})

    return data
  },
  findEquipmentsInUse: async (filial) => {
    const data = axios.get(`${defaultRoute}/in-use-details`, {
      params: {
        filial
      }
    })

    return data
  }
}
